import { render } from "./AttributModal.vue?vue&type=template&id=48fc7022"
import script from "./AttributModal.vue?vue&type=script&lang=js"
export * from "./AttributModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__